import { useCallback } from "react";
import { usePermissions } from "./usePermissions";

/**
 * Gets a loose permission checker function.
 * @returns A function which allows you to check whether the current user has any specified permissions.
 */
export function useLoosePermissionChecker(): (permissions: string | ReadonlyArray<string>) => boolean {
  const [shellPermissions] = usePermissions();
  const shellPermissionsSet = new Set(shellPermissions);

  return useCallback((permissions) => {
      if (typeof permissions === "string") return shellPermissionsSet.has(permissions);

      for (const permission of permissions) {
        if (shellPermissionsSet.has(permission)) return true;
      }

      return false;
    }, [shellPermissions]);
}
